import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74182430"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=74182430&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports